<template>
  <div class="confirmationDelete">
    <div class="confirmationDelete__header">
      <p class="confirmationDelete__title font-weight-semi-bold mb-1">
        {{ $t('general.components.delete-tiple-confirmate.title') }}
      </p>
    </div>
    <div class="confirmationDelete__body">
      <p class="confirmationDelete__description text-gray-700">
        {{ confirmationTextValue }}
      </p>
      <CInput class="confirmationDelete__input" type="text" v-model="textConfirm" />
    </div>
    <div class="confirmationDelete__footer">
      <div class="confirmationDelete__actions text-capitalize">
        <CButton :disabled="confirmString" class="confirmationDelete__btn btn btn-primary text-capitalize" @click="confirm">
          {{ $t('general.components.delete-tiple-confirmate.btn.confirm') }}
        </CButton>
        <CButton class="confirmationDelete__btn text-capitalize" @click="cancel" type="link">
          {{ $t('general.components.delete-tiple-confirmate.btn.cancel') }}
        </CButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TripleConfirmationDelete',
  props: {
    confirmationText: {
      type: String,
    },
  },
  data() {
    return {
      textConfirm: '',
    }
  },
  computed: {
    confirmationTextValue() {
      return this.confirmationText ?? this.$t('general.components.delete-tiple-confirmate.text')
    },
    confirmString() {
      return this.textConfirm === 'DELETE' ? false : true
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm')
    },

    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss" scoped>
.confirmationDelete {
  max-width: 250px;
  &__title {
  }

  &__input {
    border: 1px solid #ccc;
  }

  &__description {
  }

  &__actions {
    text-transform: capitalize;
  }

  &__btn {
  }
}
</style>
